import { singletonQueryClient } from '$utils'
import { ICostDifference } from '@loadedhub/core-api-sdk'
import { coreApi } from '$api'

/**
 * Get the cost difference for recipes using an item before and after a given invoice was received
 * @param itemId the id of the item
 * @param invoiceId the id of the invoice
 * @returns A list of recipes using the item and their cost difference
 */
export const getCostDifference = async (
  itemId: string,
  invoiceId: string
): Promise<ICostDifference[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['cost-difference', itemId, invoiceId],
    queryFn: async () => {
      return (await coreApi.costDifference(itemId, invoiceId, undefined))
        .differences
    },
  })
}
